<template>
  <section class="content">
    <BlockUI v-show="loadingShow">
      <div class="spinner-border text-info"></div>
      <p>شکیبا باشید...</p>
    </BlockUI>
    <div class="body_scroll">
      <div class="block-header">
        <div class="row">
          <div class="col-lg-7 col-md-6 col-sm-12">
            <h2>مدیریت حواله های ورودی</h2>
            <ul class="breadcrumb mt-3">
              <li class="breadcrumb-item">
                <a href="#" @click="$store.state.contentPane='Dashboard'">
                  <i class="zmdi zmdi-home"></i>پنل مدیریت
                </a>
              </li>

              <li class="breadcrumb-item active">
                <a @click="getInstallments(1,10)" href="#">مدیریت حواله های دریافتی</a>
              </li>
            </ul>
            <button class="btn btn-primary btn-icon mobile_menu" type="button">
              <i class="zmdi zmdi-sort-amount-desc"></i>
            </button>
          </div>
          <div class="col-lg-5 col-md-6 col-sm-12">
            <button class="btn btn-primary float-right right_icon_toggle_btn" type="button">
              <i class="zmdi zmdi-arrow-right align-middle"></i>
            </button>
            <!--            <button
                            class="btn btn-success float-right right_icon_toggle_btn"
                            type="button"
                            title="فروشگاه جدید"
                            data-color="red"
                            data-toggle="modal"
                            @click="openNewShopModal()"
                        >
                          <i class="zmdi zmdi-plus align-middle"></i>
                          فروشگاه جدید
                        </button>-->
            <!--            <button
                            class="btn btn-success float-right right_icon_toggle_btn"
                            type="button"
                            title="دانلود PDF لیست فروشگاه ها"
                            data-color="red"
                            data-toggle="modal"
                            @click="downloadShopList()"
                        >
                          <i class="zmdi zmdi-download align-middle"></i>
                          دانلود PDF لیست فروشگاه‌ها
                        </button>-->
            <!--            <button class="btn btn-primary float-right right_icon_toggle_btn" type="button"
                                @click="openNewContractModal">
                          قرارداد جدید
                        </button>-->
            <button class="btn btn-primary float-right right_icon_toggle_btn" type="button"
                    @click="openFindCustomerModal">
              فیلتر گذاری
            </button>
          </div>
        </div>
      </div>

      <div class="container-fluid">
        <div class="row clearfix">
          <div class="col-lg-12">
            <div class="card">
              <div class="row">
                <div class="col-lg-12">
                  <select v-model="pageSize">
                    <option value="10">10</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </div>
              </div>
              <div class="body">
                <div class="table-responsive">
                  <table
                      class="table table-bordered table-striped table-hover"
                  >
                    <thead class="bg-info">
                    <tr>
                      <th class="text-center">کد رهگیری</th>
                      <th class="text-center">شماره بارنامه</th>
                      <th class="text-center">کد تامین کننده</th>
                      <th class="text-center">نام تامین کننده</th>
                      <th class="text-center">نوع وسیله نقلیه</th>
                      <th class="text-center">راننده</th>
                      <th class="text-center">شماره محموله</th>
                      <th class="text-center">تاریخ حمل</th>
                      <th class="text-center">وضعیت</th>

                      <th class="text-center">عملیات</th>
                    </tr>
                    </thead>
                    <!--                    <tfoot class="bg-info">
                                        </tfoot>-->
                    <tbody class="text-center">
                    <tr v-if="installmentsData.InstallmentList.length===0">
                      <td class="p-3 align-middle" colspan="10">رکوردی برای نمایش وجود ندارد</td>
                    </tr>
                    <tr v-for="item in installmentsData.InstallmentList" :key="item._id">
                      <td class="p-1 align-middle">{{ item.tracking_number }}</td>
                      <td class="p-1 align-middle">{{ item.bill_of_lading }}</td>
                      <td class="p-1 align-middle">{{ item.supp_code }}</td>
                      <td class="p-1 align-middle">{{ item.supp_name }}</td>
                      <td class="p-1 align-middle">{{ item.vehicle_type }}</td>
                      <td class="p-1 align-middle">{{ item.driver2 }}</td>
                      <td class="p-1 align-middle">{{ item.asn_no }}</td>
                      <td class="p-1 align-middle">{{ item.asn_date_persian }}</td>
                      <td class="p-1 align-middle">
                        <span class="zmdi zmdi-check text-success" v-if="item.status"></span>
                        <span class="zmdi zmdi-close text-danger" v-if="!item.status"></span>
                      </td>
                      <td class="p-1 align-middle">
                        <a
                            href="#"
                            class="m-1 btn btn-primary btn-sm"
                            title="تایید محموله بدون بندیل"
                            @click="openEditContractModal(item)"
                        >
                        <i class="zmdi zmdi-check align-middle text-white"></i>
                          تایید محموله بدون بندیل
                        </a>
                        <a
                            href="#"
                            class="m-1 btn btn-primary btn-sm"
                            title="تایید محموله با بندیل"
                            @click="openConfirmBundledShipmentModal(item)"
                        >
                          <i class="zmdi zmdi-check align-middle text-white"></i>
                          تایید محموله با بندیل
                        </a>
                        <a
                            href="#"
                            class="m-1 btn btn-info btn-sm"
                            title="نمایش جزییات"
                            @click="openShipmentInfoModal(item)"
                        >
                          <i class="zmdi zmdi-eye align-middle text-white"></i>
                        </a>
                        <!--                        <a
                                                    href="#"
                                                    class="m-1 btn btn-success btn-sm"
                                                    title="محاسبه اقساط"
                                                    @click="openCalcInstallmentModal(item)"
                                                >
                                                  <i class="zmdi zmdi-file align-middle text-white"></i>
                                                </a>
                                                <a
                                                    href="#"
                                                    class="m-1 btn btn-info btn-sm"
                                                    title="پرینت قرارداد"
                                                    @click="makeContractPDF(item)"
                                                >
                                                  <i class="zmdi zmdi-print align-middle text-white"></i>
                                                </a>
                                                <a
                                                    href="#"
                                                    class="m-1 btn btn-primary btn-sm"
                                                    title="بارگزاری فایل ها"
                                                    @click="openContractFileUploadModal(item)"
                                                >
                                                  <i class="zmdi zmdi-upload align-middle text-white"></i>
                                                </a>-->
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-center">
            <!--            <ul
                            class="pagination pagination-warning d-flex flex-row justify-content-center align-items-center">
                          <li
                              class="page-item"
                              v-for="item in pageList"
                              :key="item"
                              :class="{ 'active': pageIndex === item }">
                            <a class="page-link" href="#" @click="getInstallments(item,pageSize)">{{ item }}</a>
                          </li>
                        </ul>-->
            <!--<paginate
                :page-count="pageList"
                :click-handler="getInstallments"
                :prev-text="'prev'"
                :next-text="'next'" :page-range="10"
                :container-class="'custom-pagination'">
            </paginate>-->
          </div>
        </div>
      </div>
    </div>
    <!--    <div class="modal fade" id="div_InstallmentsModal" tabindex="-1" role="dialog">
          <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-header justify-content-between pt-3">
                <span class="title">مشاهده اقساط</span>
                <span data-dismiss="modal" class="btn btn-link text-muted pt-0">بستن</span>
              </div>
              <div class="modal-body">
                <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:400px;">
                  <div>
                    <form>
                      <div class="row m-0">
                        <div class="col-md-12">
                          <div class="table-responsive">
                            <table
                                class="table table-bordered table-striped table-hover"
                            >
                              <thead>
                              <tr>
                                <th class="text-center">ردیف</th>
                                <th class="text-center">تاریخ سررسید</th>
                                <th class="text-center">مبلغ</th>
                                <th class="text-center">وضعیت پرداخت</th>
                              </tr>
                              </thead>
                              <tfoot>
                              <tr>
                                <th class="text-center">ردیف</th>
                                <th class="text-center">تاریخ سررسید</th>
                                <th class="text-center">مبلغ</th>
                                <th class="text-center">وضعیت پرداخت</th>
                              </tr>
                              </tfoot>
                              <tbody class="text-center">
                              <tr v-for="(item,index) in installments" :key="item._id">
                                <td class="p-1 align-middle">{{
                                    index + 1
                                  }}
                                </td>
                                <td class="p-1 align-middle">{{
                                    item.DueDate | moment("jYYYY/jM/jD")
                                  }}
                                </td>
                                <td class="p-1 align-middle">
                                  {{ item.Amount.toString().replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}
                                </td>
                                <td class="p-1 align-middle">
                                  <span class="zmdi zmdi-check text-success" v-if="item.Status">

                                                                          </span>
                                  <span class="zmdi zmdi-close text-danger" v-else-if="!item.Status">

                                                                          </span>

                                </td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      &lt;!&ndash;                  <button
                                            type="submit"
                                            class="btn btn-raised btn-success btn-round waves-effect"
                                        >اعمال کن
                                        </button>&ndash;&gt;
                    </form>
                  </div>
                </simplebar>
              </div>
            </div>
          </div>
        </div>-->


    <!--    <div class="modal fade" id="div_InstallmentsFilter" tabindex="-1" role="dialog">
          <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-header justify-content-between pt-3">
                <span class="title">فیلتر گذاری</span>
                <span data-dismiss="modal" class="btn btn-link text-muted pt-0">بستن</span>
              </div>
              <div class="modal-body">
                <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:400px;">
                  <div>
                    <form @submit.prevent="submitFilter()">
                      <div class="row m-0">
                        <div class="col-md-12">
                          <label>سال</label>
                          <div class="form-group">
                            <select
                                class="form-control show-tick ms select2"
                                data-placeholder="انتخاب کنید"
                                style="height:auto;" v-model="filterFields.Year">
                              <option value="All">
                                همه
                              </option>
                              <option value="1400">
                                1400
                              </option>
                              <option value="1401">
                                1401
                              </option>
                              <option value="1402">
                                1402
                              </option>
                              <option value="1403">
                                1403
                              </option>
                              <option value="1404">
                                1404
                              </option>
                              <option value="1405">
                                1405
                              </option>
                              <option value="1406">
                                1406
                              </option>
                              <option value="1407">
                                1407
                              </option>
                              <option value="1408">
                                1408
                              </option>
                              <option value="1409">
                                1409
                              </option>
                              <option value="1410">
                                1410
                              </option>
                            </select>
                          </div>
                        </div>

                        <div class="col-md-12">
                          <label>ماه</label>
                          <div class="form-group">
                            <select
                                class="form-control show-tick ms select2"
                                data-placeholder="انتخاب کنید"
                                style="height:auto;" v-model="filterFields.Month">
                              <option value="All">
                                همه
                              </option>
                              <option value="1">
                                فروردین(ماه اول)
                              </option>
                              <option value="2">
                                اردیبهشت(ماه دوم)
                              </option>
                              <option value="3">
                                خرداد(ماه سوم)
                              </option>
                              <option value="4">
                                تیر(ماه چهارم)
                              </option>
                              <option value="5">
                                مرداد(ماه پنجم)
                              </option>
                              <option value="6">
                                شهریور(ماه ششم)
                              </option>
                              <option value="7">
                                مهر(ماه هفتم)
                              </option>
                              <option value="8">
                                آبان(ماه هشتم)
                              </option>
                              <option value="9">
                                آذر(ماه نهم)
                              </option>
                              <option value="10">
                                دی(ماه دهم)
                              </option>
                              <option value="11">
                                بهمن(ماه یازدهم)
                              </option>
                              <option value="12">
                                اسفند(ماه دوازدهم)
                              </option>
                            </select>
                          </div>
                        </div>

                        <div class="col-md-12">
                          <label>کد پرسنلی</label>
                          <div class="form-group">
                            <input type="text" class="form-control text-left"
                                   v-model="filterFields.PersonalCode"
                                   placeholder="9 رقمی باشد"/>
                          </div>
                        </div>


                      </div>
                      <button
                          type="submit"
                          class="btn btn-raised btn-success btn-round waves-effect"
                      >اعمال کن
                      </button>
                    </form>
                  </div>
                </simplebar>
              </div>
            </div>
          </div>
        </div>-->


    <!--    <div class="modal fade" id="div_EditContractModal" tabindex="-1" role="dialog">
          <div class="modal-dialog modal-dialog-centered modal-md" role="document">
            <div class="modal-content">
              <div class="modal-header justify-content-between pt-3">
                <span class="title">ویرایش قرارداد</span>
                <span data-dismiss="modal" class="btn btn-link text-muted pt-0">بستن</span>
              </div>
              <div class="modal-body">
                <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:400px;">
                  <div>
                    <form @submit.prevent="updateContract()">
                      <div class="row m-0">
                        &lt;!&ndash;                    <div class="col-md-12">
                                              <label>وضعیت پرداخت</label>
                                              <div class="form-group">
                                                <select
                                                    class="form-control show-tick ms select2"
                                                    data-placeholder="انتخاب کنید"
                                                    style="height:auto;" v-model="installmentPayment.PaymentStatus">

                                                  <option value="true">
                                                    پرداخت شده
                                                  </option>
                                                  <option value="false">
                                                    پرداخت نشده
                                                  </option>
                                                </select>
                                              </div>
                                            </div>&ndash;&gt;
                        <div class="col-md-12">
                          <label>کدملی</label>
                          <div class="form-group">
                            <input type="text" class="form-control text-left"
                                   v-model="contractFields.NationalCode" required maxlength="10"/>
                          </div>
                        </div>
    &lt;!&ndash;                    <div class="col-md-12">
                          <label>نام پدر</label>
                          <div class="form-group">
                            <input type="text" class="form-control text-right"
                                   v-model="contractFields.FatherName" required/>
                          </div>
                        </div>&ndash;&gt;

    &lt;!&ndash;                    <div class="col-md-12">
                          <label>محل صدور</label>
                          <div class="form-group">
                            <input type="text" class="form-control text-right"
                                   v-model="contractFields.BirthCertificatePlace" required/>
                          </div>
                        </div>&ndash;&gt;

                        <div class="col-md-12">
                          <label>آدرس محل سکونت</label>
                          <div class="form-group">
                            <input type="text" class="form-control text-right"
                                   v-model="contractFields.HomeAddress" required/>
                          </div>
                        </div>

    &lt;!&ndash;                    <div class="col-md-12">
                          <label>آدرس محل کار</label>
                          <div class="form-group">
                            <input type="text" class="form-control text-right"
                                   v-model="contractFields.WorkPlace" required/>
                          </div>
                        </div>&ndash;&gt;

                        <div class="col-md-12">
                          <label>تلفن منزل</label>
                          <div class="form-group">
                            <input type="text" class="form-control text-left"
                                   v-model="contractFields.HomeCellphone" required maxlength="11"/>
                          </div>
                        </div>

    &lt;!&ndash;                    <div class="col-md-12">
                          <label>تلفن محل کار</label>
                          <div class="form-group">
                            <input type="text" class="form-control text-left"
                                   v-model="contractFields.WorkPlaceCellphone" maxlength="11"/>
                          </div>
                        </div>&ndash;&gt;

                        <div class="col-md-12">
                          <label>تاریخ شروع قرارداد</label>
                          <div class="form-group">
                            &lt;!&ndash;                        <input type="text" class="form-control text-left"
                                                           v-model="contractFields.StartContractDate" required/>&ndash;&gt;
                            <date-picker
                                type="date"
                                :autoSubmit="true"
                                format="YYYY-MM-DD"
                                display-format="jDD jMMMM jYYYY"
                                v-model="contractFields.StartContractDate"
                            ></date-picker>
                          </div>
                        </div>

                        <div class="col-md-12">
                          <label>تاریخ پایان قرارداد</label>
                          <div class="form-group">
                            <date-picker
                                type="date"
                                :autoSubmit="true"
                                format="YYYY-MM-DD"
                                display-format="jDD jMMMM jYYYY"
                                v-model="contractFields.EndContractDate"
                            ></date-picker>
                            &lt;!&ndash;                        <input type="text" class="form-control text-left"
                                                           v-model="contractFields.EndContractDate" required/>&ndash;&gt;
                          </div>
                        </div>
                      </div>
                      <button
                          type="submit"
                          class="btn btn-raised btn-success btn-round waves-effect"
                      >
                        اطلاعات را ثبت کن
                      </button>
                    </form>
                  </div>
                </simplebar>
              </div>
            </div>
          </div>
        </div>-->


    <!--    <div class="modal fade" id="div_CalcInstallmentModal" tabindex="-1" role="dialog">
          <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-header justify-content-between pt-3">
                <span class="title">محاسبه اقساط</span>
                <span data-dismiss="modal" class="btn btn-link text-muted pt-0">بستن</span>
              </div>
              <div class="modal-body">
                <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:400px;">
                  <div>
                    <form @submit.prevent="calcInstallment()">
                      <div class="row m-0">

                        <div class="col-md-12">
                          <label>مبلغ کل قرارداد(ریال)</label>
                          <div class="form-group">
                            <input type="text" class="form-control text-left" v-model="contractFields.TotalAmount"
                                   required/>
                          </div>
                        </div>

                        <div class="col-md-12">
                          <label>مبلغ پیش پرداخت(ریال)</label>
                          <div class="form-group">
                            <input type="text" class="form-control text-left" v-model="contractFields.Prepayment" required/>
                          </div>
                        </div>

                        <div class="col-md-12">
                          <label>مبلغ تخفیف(ریال)</label>
                          <div class="form-group">
                            <input type="text" class="form-control text-left" v-model="contractFields.AmountDiscount"
                                   required/>
                          </div>
                        </div>


                        <div class="col-md-12">
                          <label>مبلغ قسط(ریال)</label>
                          <div class="form-group">
                            <input type="text" class="form-control text-left" v-model="contractFields.InstallmentAmount"
                                   required/>
                          </div>
                        </div>

                        <div class="col-md-12">
                          <label>تعداد اقساط</label>
                          <div class="form-group">
                            <input type="text" class="form-control text-left" v-model="contractFields.InstallmentCount"
                                   required/>
                          </div>
                        </div>


                        <div class="col-md-12">
                          <label>تاریخ شروع قسط</label>
                          <div class="form-group">
                            <date-picker
                                type="date"
                                :autoSubmit="true"
                                format="YYYY-MM-DD"
                                display-format="jDD jMMMM jYYYY"
                                v-model="contractFields.StartInstallment"
                            ></date-picker>
                          </div>
                        </div>


                        <div class="col-md-12" v-if="contractFields.SellingType!='نقد'">
                          <div class="mb-3">
                            <fieldset class="reset border">
                              <legend class="reset">
                                <h6>
                                  چک های ضمانت
                                </h6>
                              </legend>
                              <div class="border-1 border border-danger p-2">
                                <div class="mb-3">
                                  <label class="form-label">
                                    صاحب چک:
                                  </label>
                                  <input type="text" class="form-control text-right"
                                         v-model="contractFields.ChequeInfo.ChequeHolder">
                                </div>
                                <div class="mb-3">
                                  <label class="form-label">
                                    بانک چک:
                                  </label>
                                  <input type="text" class="form-control text-right"
                                         v-model="contractFields.ChequeInfo.BankCheque">
                                </div>
                                <div class="mb-3">
                                  <label class="form-label">
                                    مبلغ چک(ریال):
                                  </label>
                                  <input type="text" class="form-control text-left"
                                         v-model="contractFields.ChequeInfo.ChequeAmount">
                                </div>
                                <div class="mb-3">
                                  <label class="form-label">
                                    تاریخ چک:
                                  </label>
                                  <date-picker
                                      type="date"
                                      :autoSubmit="true"
                                      format="YYYY-MM-DD"
                                      display-format="jDD jMMMM jYYYY"
                                      v-model="contractFields.ChequeInfo.ChequeDate"
                                  ></date-picker>
                                  &lt;!&ndash;                              <input type="text" class="form-control text-left"
                                                                       v-model="contractFields.ChequeInfo.ChequeDate" placeholder="مثال 1402/01/20">&ndash;&gt;

                                </div>
                                <button type="button" class="btn btn-success w-100 rounded-0" @click="addChequeToList">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                       class="bi bi-plus-lg" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd"
                                          d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"/>
                                  </svg>
                                  به لیست چک های دریافت شده اضافه کن
                                </button>
                              </div>

                              <fieldset v-for="(item,index) in contractFields.ChequeList" :key="index"
                                        class="reset border-1 border border-info p-2 mt-2">
                                <legend class="reset">
                                  چک
                                  {{ index + 1 }}
                                  <span @click="removeChequeFromList(index)">
                                           <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="red"
                                                class="bi bi-x-lg"
                                                viewBox="0 0 16 16">
                                          <path
                                              d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                                        </svg>
                                        </span>
                                </legend>
                                <div class="mb-3">
                                  <span>
                                    چک
                                  </span>
                                  <span>
                                          {{ item.ChequeHolder }}
                                  </span>
                                  <span>
                                          بانک
                                  </span>
                                  <span>
                                          {{ item.BankCheque }}
                                  </span>
                                  <span>
                                          مبلغ
                                  </span>
                                  <span>
                                          {{ item.ChequeAmount }}
                                  </span>
                                  <span>
                                    به تاریخ
                                  </span>
                                  <span>
                                    {{ item.ChequeDate | moment("jYYYY/jM/jD") }}

                                  </span>
                                </div>
                              </fieldset>
                            </fieldset>
                          </div>
                        </div>

                        &lt;!&ndash;              <div class="mb-3"
                                     v-if="contractFields.SellingType==='چک ضمانت' || contractFields.SellingType==='چک دوره'">
                                  <fieldset class="reset border">
                                    <legend class="reset">
                                      اطلاعات چک(های) ضمانت
                                    </legend>
                                    <div class="border-1 border border-danger p-2">
                                      <div class="mb-3">
                                        <label class="form-label">
                                          صاحب چک:
                                        </label>
                                        <input type="text" class="form-control text-right"
                                               v-model="contractFields.ChequeInfo.ChequeHolder">
                                      </div>
                                      <div class="mb-3">
                                        <label class="form-label">
                                          بانک چک:
                                        </label>
                                        <input type="text" class="form-control text-right" v-model="contractFields.ChequeInfo.BankCheque">
                                      </div>
                                      <div class="mb-3">
                                        <label class="form-label">
                                          مبلغ چک(ریال):
                                        </label>
                                        <input type="text" class="form-control text-left"
                                               v-model="contractFields.ChequeInfo.ChequeAmount">
                                      </div>
                                      <div class="mb-3">
                                        <label class="form-label">
                                          تاریخ چک:
                                        </label>
                                        <input type="text" class="form-control text-left"
                                               v-model="contractFields.ChequeInfo.ChequeDate" v-maska:[options] placeholder="مثال 1402/01/20">

                                      </div>
                                      <button type="button" class="btn btn-success w-100 rounded-0" @click="addChequeToList">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                             class="bi bi-plus-lg" viewBox="0 0 16 16">
                                          <path fill-rule="evenodd"
                                                d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"/>
                                        </svg>
                                        به لیست چک های دریافت شده اضافه کن
                                      </button>
                                    </div>

                                    <fieldset v-for="(item,index) in contractFields.ChequeList" :key="index"
                                              class="reset border-1 border border-info p-2 mt-2">
                                      <legend class="reset">
                                        چک
                                        {{ index + 1 }}
                                        <span @click="removeChequeFromList(index)">
                                           <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="red" class="bi bi-x-lg"
                                                viewBox="0 0 16 16">
                                          <path
                                              d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                                        </svg>
                                        </span>

                                      </legend>
                                      <div class="mb-3">
                                        <span>
                                          چک
                                        </span>
                                        <span>
                                          {{ item.ChequeHolder }}
                                        </span>
                                        <span>
                                          بانک
                                        </span>
                                        <span>
                                          {{ item.BankCheque }}
                                        </span>
                                        <span>
                                          مبلغ
                                        </span>
                                        <span>
                                          {{ item.ChequeAmount }}
                                        </span>
                                      </div>
                                    </fieldset>
                                  </fieldset>
                                </div>&ndash;&gt;

                      </div>
                      <button
                          type="submit"
                          class="btn btn-raised btn-success btn-round waves-effect"
                      >
                        اقساط را ثبت کن
                      </button>
                    </form>
                  </div>
                </simplebar>
              </div>
            </div>
          </div>
        </div>-->


    <!--    <div class="modal fade" id="div_ContractFilesModal" tabindex="-1" role="dialog">
          <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-header justify-content-between pt-3">
                <span class="title">مدارک بارگزاری شده</span>
                <span data-dismiss="modal" class="btn btn-link text-muted pt-0">بستن</span>
              </div>
              <div class="modal-body">
                <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:400px;">
                  <div>

                    <div class="row m-0">
                      <div class="col-md-12 border border-info">
                        <form @submit.prevent="uploadFile">
                          <div class="row m-0">
                            <div class="col-md-12">
                              <label class="mb-0">نوع مدرک</label>
                              <div class="form-group">
                                <select id="ddl_ContractType" class="form-control form-control-lg rounded-0"
                                        v-model="contractFields.ContractFile.DocType">
                                  <option value="" disabled selected>&#45;&#45; یک مورد را انتخاب کنید &#45;&#45;</option>
                                  <option value="Contract">قرارداد</option>
                                  <option value="Cheque">چک</option>
                                  <option value="Validation">اعتبار سنجی</option>
                                </select>
                              </div>
                            </div>

                            <div class="col-md-12">
                              <label class="mb-0">
                                انتخاب فایل
                              </label>
                              <div class="form-group">
                                <input class="form-control" type="file" id="fu_ContractFile"
                                       accept="image/png, image/jpeg,application/pdf" ref="fu_ContractFile"
                                       v-on:change="onChangeContractFile()">
                              </div>

                            </div>
                          </div>

                          <div class="row m-0"></div>

                          <button
                              type="submit"
                              class="btn btn-raised btn-success btn-round waves-effect"
                          >بارگزاری کن
                          </button>
                        </form>


                      </div>
                      <div class="col-md-12" v-for="(item, index) in contractFields.Files" :key="index">
                        <div class="form-group bg-light p-2">
                          <a :href="`https://server.arakcarpethall.ir/${contractFields.User.Mobile}/${item.Name}`"
                             target="_blank">
                            <p class="p-1 m-0">
                              {{ item.Type }}
                            </p>
                            <p class="p-1 m-0">
                              {{ item.Name }}
                            </p>
                            <p class="p-1 m-0">
                              {{ item.CreatedAt | moment("HH:mm - jYYYY/jM/jD") }}
                            </p>
                          </a>
                        </div>
                      </div>


                      <div class="col-md-12">
                        <br/>
                      </div>
                    </div>

                    <div class="row m-0"></div>
                  </div>
                </simplebar>
              </div>
            </div>
          </div>
        </div>-->


    <!--    <div class="modal fade" data-backdrop="static" data-keyboard="false" id="div_NewContractModal" tabindex="-1" role="dialog">
          <div class="modal-dialog modal-dialog-centered modal-md" role="document">
            <div class="modal-content">
              <div class="modal-header justify-content-between pt-3">
                <span class="title">قرارداد جدید</span>
                <span data-dismiss="modal" class="btn btn-link text-muted pt-0">بستن</span>
              </div>
              <div class="modal-body">
                <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:680px;">
                  <form v-if="FormActive==='CalcForm'">
                    <div class="mb-3">
                      <label  class="form-label">مبلغ کل(ریال)</label>
                      <input type="text" class="form-control mp-custom-input-text" v-model="contractFields.TotalAmount">
                    </div>

                    <div class="mb-3">
                      <label  class="form-label">تعداد اقساط</label>
                      <input type="number" class="form-control mp-custom-input-text" v-model="contractFields.InstallmentCount">
                    </div>

                    <div class="mb-3">
                      <label  class="form-label">مبلغ پیش پرداخت(ریال)</label>
                      <input type="text" class="form-control mp-custom-input-text" v-model="contractFields.Prepayment">
                    </div>

                    <div class="mb-3">
                      <label  class="form-label">مبلغ تخفیف(ریال)</label>
                      <input type="text" class="form-control mp-custom-input-text" v-model="contractFields.AmountDiscount">
                    </div>

                    <div class="mb-3">
                      <label  class="form-label">درصد تخفیف</label>
                      <input type="text" class="form-control mp-custom-input-text" v-model="contractFields.DiscountPercent" disabled>
                    </div>

                    <div class="mb-3">
                      <label  class="form-label">باقی مانده اقساط(ریال)</label>
                      <input type="text" class="form-control mp-custom-input-text" v-model="contractFields.TotalInstallmentAmount" disabled>
                    </div>

                    <div class="mb-3">
                      <label  class="form-label">مبلغ هر قسط(ریال)</label>
                      <input type="text" class="form-control mp-custom-input-text" v-model="contractFields.InstallmentAmount" disabled>
                    </div>
                    <div>
                      <button type="button" class="btn btn-primary" @click="FormActive='CustomerInfo'">مرحله بعد</button>
                      <button type="button" class="btn btn-secondary" data-dismiss="modal">پاک کردن فرم محاسبه</button>
                    </div>
                  </form>

                  <form @submit.prevent="saveContract" v-else-if="FormActive==='CustomerInfo'">
                    <div class="mb-3">
                      <label class="form-label">نام</label>
                      <input type="text" class="form-control" required v-model="contractFields.FirstName">
                    </div>
                    <div class="mb-3">
                      <label class="form-label">نام خانوادگی</label>
                      <input type="text" class="form-control" required v-model="contractFields.LastName">
                    </div>
                    <div class="mb-3">
                      <label class="form-label">
                        جنسیت:
                      </label>
                      <select class="form-control" aria-label="Default select example"
                              v-model="contractFields.Gender"
                              required>
                        <option selected disabled value="0">انتخاب نمایید</option>
                        <option value="true">آقا</option>
                        <option value="false">خانم</option>
                      </select>
                    </div>

                    <div class="mb-3">
                      <label class="form-label">
                        تلفن همراه
                        <strong class="text-danger">
                          با دقت وارد شود
                        </strong>
                      </label>
                      <input type="text" class="form-control text-left" maxlength="11" required
                             v-model="contractFields.Mobile">
                    </div>

                    <div class="mb-3">
                      <label class="form-label">
                        اقلام فروش
                      </label>
                      <textarea rows="4" cols="50" class="form-control text-right"
                                v-model="contractFields.SaleItems"
                                placeholder="اقلام فروش را در اینجا وارد کنید" required>
                    </textarea>
                    </div>


                    <div class="mb-3">
                      <label class="form-label">
                        نوع فروش
                      </label>
                      <select class="form-control" aria-label="Default select example"
                              v-model="contractFields.SellingType"
                              required>
                        <option value="نقد">نقد</option>
                        <option value="چک ضمانت">چک ضمانت</option>
                        <option value="چک دوره">چک دوره‌ای</option>
                      </select>
                    </div>

                    <div class="mb-3">
                      <label class="form-label">
                        مبلغ کل فاکتور(ریال)
                      </label>
                      <input type="text" class="form-control text-left" :value="contractFields.TotalAmount"
                             disabled>
                    </div>
                    <div class="mb-3">
                      <label class="form-label">
                        مبلغ پیش پرداخت(ریال)
                      </label>
                      <input type="text" class="form-control text-left" disabled
                             :value="contractFields.Prepayment">
                    </div>
                    <div class="mb-3">
                      <label class="form-label">
                        مبلغ تخفیف(ریال)
                      </label>
                      <input type="text" class="form-control text-left" disabled
                             :value="contractFields.AmountDiscount">
                    </div>
                    <div class="mb-3">
                      <label class="form-label">
                        تعداد اقساط
                      </label>
                      <input type="text" class="form-control text-left" disabled
                             :value="contractFields.InstallmentCount">
                    </div>
                    <div class="mb-3">
                      <label class="form-label">
                        مبلغ هر قسط(ریال)
                      </label>
                      <input type="text" class="form-control text-left" disabled
                             :value="contractFields.InstallmentAmount">
                    </div>
                    <div class="mb-3">
                      <button type="submit" class="btn btn-success">قرارداد را ذخیره کن</button>
                      <button type="button" class="btn btn-secondary" @click="FormActive='CalcForm'">مرحله قبل</button>
                    </div>
                  </form>

                </simplebar>
              </div>

            </div>
          </div>
        </div>-->

    <div id="div_FilterModal" data-backdrop="static" data-keyboard="false" class="modal fade">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header justify-content-between pt-3">
            <span class="title">فیلتر گذاری</span>
            <span data-dismiss="modal" class="btn btn-link text-muted pt-0">بستن</span>
          </div>
          <form @submit.prevent="filterIncomingRemittances">
            <div class="modal-body">
              <div role="alert" ref="filterIncomingRemittancesAlert"></div>
              <div class="col-md-12 mb-3">
                <label class="form-label">
                  فیلتر بر اساس
                </label>
                <select class="form-control" aria-label="Default select example"
                        required v-model="filterFields.SelectFilter">
                  <option selected disabled value="0">انتخاب نمایید</option>
                  <option value="DateRange">بازه زمانی</option>
                  <option value="BOLNumber">شماره بارنامه</option>
                </select>
              </div>
              <div v-if="filterFields.SelectFilter==='DateRange'">
                <div class="col-md-12">
                  <label>از تاریخ</label>
                  <div class="form-group">
                    <date-picker
                        type="date"
                        :autoSubmit="true"
                        format="jYYYY/jMM/jDD"
                        display-format="jYYYY/jMM/jDD"
                        v-model="filterFields.FromDate"
                    ></date-picker>
                  </div>
                </div>
                <div>
                  <div class="col-md-12">
                    <label>تا تاریخ</label>
                    <div class="form-group">
                      <date-picker
                          type="date"
                          :autoSubmit="true"
                          format="jYYYY/jMM/jDD"
                          display-format="jYYYY/jMM/jDD"
                          v-model="filterFields.ToDate"
                      ></date-picker>
                    </div>
                  </div>
                </div>

              </div>
              <div v-else-if="filterFields.SelectFilter==='BOLNumber'">
                <div class="col-md-12">
                  <label class="form-label">شماره بارنامه</label>
                  <input type="text" class="form-control text-left" v-model="filterFields.BOLNumber">
                </div>
              </div>


            </div>
            <div class="modal-footer">
              <div class="col d-grid gap-2 d-md-flex justify-content-md-start">
                <input type="submit" class="btn btn-success rounded-0" value="فیلتر کن">
              </div>
            </div>
          </form>
        </div>

      </div>
    </div>


    <div class="modal fade" id="div_ShipmentConfirmationModal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header justify-content-between pt-3">
                            <span class="title">
                              تایید محموله بدون بندیل
                            </span>
            <span data-dismiss="modal" class="btn btn-link text-muted pt-0">بستن</span>
          </div>
          <div class="modal-body">
            <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:400px;">
              <div>
                <form @submit.prevent="confirmUnbundledShipment">
                  <div class="row m-0">

                    <div class="col-md-12">
                      <label>
                        شماره بارنامه
                      </label>
                      <div class="form-group">
                        <input type="text" class="form-control text-left"
                               v-model="shipmentConfirmationFields.BillLading"/>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <label>
                        کد تامین کننده
                      </label>
                      <div class="form-group">
                        <input type="number" class="form-control text-left"
                               v-model="shipmentConfirmationFields.SuppCode"/>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <label>
                        کد تحویل گیرنده
                      </label>
                      <div class="form-group">
                        <input type="number" class="form-control text-left"
                               v-model="shipmentConfirmationFields.DeliverSuppCode"/>
                      </div>
                    </div>


                    <div class="col-md-12">
                      <label>
                        شماره محموله
                      </label>
                      <div class="form-group">
                        <input type="number" class="form-control text-left"
                               v-model="shipmentConfirmationFields.AsnNo"/>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <label>
                        کد کالا
                      </label>
                      <div class="form-group">
                        <input type="number" class="form-control text-left"
                               v-model="shipmentConfirmationFields.ItemCode"/>
                      </div>
                    </div>


                    <div class="col-md-12">
                      <label>
                        شماره سند مرجع
                      </label>
                      <div class="form-group">
                        <input type="number" class="form-control text-left"
                               v-model="shipmentConfirmationFields.ItemRefDoc"/>
                      </div>
                    </div>


                    <div class="col-md-12">
                      <label>
                        تاريخ سند مرجع
                      </label>
                      <div class="form-group">
                        <input type="text" class="form-control text-left"
                               v-model="shipmentConfirmationFields.ItemRefDate"/>
                      </div>
                    </div>


                    <div class="col-md-12">
                      <label>
                        تعداد تاييد شده (تعداد دريافت)
                      </label>
                      <div class="form-group">
                        <input type="number" class="form-control text-left"
                               v-model="shipmentConfirmationFields.AppItemQty"/>
                      </div>
                    </div>


                    <div class="col-md-12">
                      <label>
                        تعداد رد شده (تعداد عدم دريافت)
                      </label>
                      <div class="form-group">
                        <input type="number" class="form-control text-left"
                               v-model="shipmentConfirmationFields.RejItemQty"/>
                      </div>
                    </div>


                    <!--<div class="col-md-12">
                      <label>
                        شماره بندیل
                      </label>
                      <div class="form-group">
                        <input type="number" class="form-control text-left"
                               v-model="shipmentConfirmationFields.ContNo"/>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <label>
                        شماره صندوق
                      </label>
                      <div class="form-group">
                        <input type="number" class="form-control text-left"
                               v-model="shipmentConfirmationFields.CaseNo"/>
                      </div>
                    </div>-->




                  </div>

                  <button
                      type="submit"
                      class="btn btn-raised btn-success btn-round waves-effect"
                  >ذخیره کن
                  </button>
                </form>
              </div>
            </simplebar>
          </div>
        </div>
      </div>
    </div>


    <div class="modal fade" id="div_ConfirmBundledShipmentModal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header justify-content-between pt-3">
                            <span class="title">
                              تایید محموله با بندیل
                            </span>
            <span data-dismiss="modal" class="btn btn-link text-muted pt-0">بستن</span>
          </div>
          <div class="modal-body">
            <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:400px;">
              <div>
                <form @submit.prevent="confirmUnbundledShipment">
                  <div class="row m-0">

                    <div class="col-md-12">
                      <label>
                        شماره بارنامه
                      </label>
                      <div class="form-group">
                        <input type="text" class="form-control text-left"
                               v-model="shipmentConfirmationFields.BillLading"/>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <label>
                        کد تامین کننده
                      </label>
                      <div class="form-group">
                        <input type="number" class="form-control text-left"
                               v-model="shipmentConfirmationFields.SuppCode"/>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <label>
                        کد تحویل گیرنده
                      </label>
                      <div class="form-group">
                        <input type="number" class="form-control text-left"
                               v-model="shipmentConfirmationFields.DeliverSuppCode"/>
                      </div>
                    </div>


                    <div class="col-md-12">
                      <label>
                        شماره محموله
                      </label>
                      <div class="form-group">
                        <input type="number" class="form-control text-left"
                               v-model="shipmentConfirmationFields.AsnNo"/>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <label>
                        کد کالا
                      </label>
                      <div class="form-group">
                        <input type="number" class="form-control text-left"
                               v-model="shipmentConfirmationFields.ItemCode"/>
                      </div>
                    </div>


                    <div class="col-md-12">
                      <label>
                        شماره سند مرجع
                      </label>
                      <div class="form-group">
                        <input type="number" class="form-control text-left"
                               v-model="shipmentConfirmationFields.ItemRefDoc"/>
                      </div>
                    </div>


                    <div class="col-md-12">
                      <label>
                        تاريخ سند مرجع
                      </label>
                      <div class="form-group">
                        <input type="text" class="form-control text-left"
                               v-model="shipmentConfirmationFields.ItemRefDate"/>
                      </div>
                    </div>


                    <div class="col-md-12">
                      <label>
                        تعداد تاييد شده (تعداد دريافت)
                      </label>
                      <div class="form-group">
                        <input type="number" class="form-control text-left"
                               v-model="shipmentConfirmationFields.AppItemQty"/>
                      </div>
                    </div>


                    <div class="col-md-12">
                      <label>
                        تعداد رد شده (تعداد عدم دريافت)
                      </label>
                      <div class="form-group">
                        <input type="number" class="form-control text-left"
                               v-model="shipmentConfirmationFields.RejItemQty"/>
                      </div>
                    </div>


                    <!--<div class="col-md-12">
                      <label>
                        شماره بندیل
                      </label>
                      <div class="form-group">
                        <input type="number" class="form-control text-left"
                               v-model="shipmentConfirmationFields.ContNo"/>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <label>
                        شماره صندوق
                      </label>
                      <div class="form-group">
                        <input type="number" class="form-control text-left"
                               v-model="shipmentConfirmationFields.CaseNo"/>
                      </div>
                    </div>-->




                  </div>

                  <button
                      type="submit"
                      class="btn btn-raised btn-success btn-round waves-effect"
                  >ذخیره کن
                  </button>
                </form>
              </div>
            </simplebar>
          </div>
        </div>
      </div>
    </div>


    <div class="modal fade" id="div_ShipmentInfoModal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header justify-content-between pt-3">
                            <span class="title">
                              جزئیات محموله
                            </span>
            <span data-dismiss="modal" class="btn btn-link text-muted pt-0">بستن</span>
          </div>
          <div class="modal-body">
            <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:400px;">
              <div>
                <form >
                  <div class="row m-0">

                    <div class="col-md-12">
                      <label>
                        شماره پیگیری
                      </label>
                      <div class="form-group">
                        <input type="text" class="form-control text-left"
                               v-model="shipmentFields.tracking_number" disabled/>
                      </div>
                    </div>


                    <div class="col-md-12">
                      <label>
                        شماره بارنامه
                      </label>
                      <div class="form-group">
                        <input type="text" class="form-control text-left" disabled v-model="shipmentFields.bill_of_lading"/>
                      </div>
                    </div>


                    <div class="col-md-12">
                      <label>
                        کد تامین کننده
                      </label>
                      <div class="form-group">
                        <input type="text" class="form-control text-left" disabled v-model="shipmentFields.supp_code"/>
                      </div>
                    </div>


                    <div class="col-md-12">
                      <label>
                        نام تامین کننده
                      </label>
                      <div class="form-group">
                        <input type="text" class="form-control text-right" disabled v-model="shipmentFields.supp_name"/>
                      </div>
                    </div>


                    <div class="col-md-12">
                      <label>
                        وسیله نقلیه
                      </label>
                      <div class="form-group">
                        <input type="text" class="form-control text-right" disabled v-model="shipmentFields.vehicle_type"/>
                      </div>
                    </div>


                    <div class="col-md-12">
                      <label>
                        راننده
                      </label>
                      <div class="form-group">
                        <input type="text" disabled class="form-control text-right" v-model="shipmentFields.driver1"/>
                      </div>
                    </div>


                    <div class="col-md-12">
                      <label>
                        نوع محموله
                      </label>
                      <div class="form-group">
                        <input type="text" disabled class="form-control text-right" v-model="shipmentFields.asn_type"/>
                      </div>
                    </div>


                    <div class="col-md-12">
                      <label>
                        شماره محموله
                      </label>
                      <div class="form-group">
                        <input type="text" disabled class="form-control text-left" v-model="shipmentFields.asn_no"/>
                      </div>
                    </div>


                    <div class="col-md-12">
                      <label>
                        تاریخ محموله
                      </label>
                      <div class="form-group">
                        <input type="text" disabled class="form-control text-left" v-model="shipmentFields.asn_date_persian"/>
                      </div>
                    </div>


                    <div class="col-md-12">
                      <label>
                        نوع بسته بندی
                      </label>
                      <div class="form-group">
                        <input type="text" disabled class="form-control text-left" v-model="shipmentFields.packing_type"/>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <label>
                       کد آیتم
                      </label>
                      <div class="form-group">
                        <input type="text" disabled class="form-control text-left" v-model="shipmentFields.item_code"/>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <label>
                        نام آیتم
                      </label>
                      <div class="form-group">
                        <input type="text" disabled class="form-control text-right" v-model="shipmentFields.item_name"/>
                      </div>
                    </div>


                    <div class="col-md-12">
                      <label>
                        واحد آیتم
                      </label>
                      <div class="form-group">
                        <input type="text" disabled class="form-control text-right" v-model="shipmentFields.item_uom_name"/>
                      </div>
                    </div>


                    <div class="col-md-12">
                      <label>
                        تعداد آیتم
                      </label>
                      <div class="form-group">
                        <input type="text" disabled class="form-control text-left" v-model="shipmentFields.item_qty"/>
                      </div>
                    </div>


                    <div class="col-md-12">
                      <label>
                        نوع PCMT
                      </label>
                      <div class="form-group">
                        <input type="text" disabled class="form-control text-right" v-model="shipmentFields.pcmt_type"/>
                      </div>
                    </div>


                    <div class="col-md-12">
                      <label>
                        کد LOCN
                      </label>
                      <div class="form-group">
                        <input type="text" disabled class="form-control text-left" v-model="shipmentFields.locn_code"/>
                      </div>
                    </div>


                    <div class="col-md-12">
                      <label>
                        نام LOCN
                      </label>
                      <div class="form-group">
                        <input type="text" disabled class="form-control text-right" v-model="shipmentFields.locn_name"/>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <label>
                       وضعیت
                      </label>
                      <div class="form-group">
                        <input type="text" disabled class="form-control text-right" v-model="shipmentFields.status"/>
                      </div>
                    </div>



                  </div>

<!--                  <button
                      type="submit"
                      class="btn btn-raised btn-success btn-round waves-effect"
                  >ذخیره کن
                  </button>-->
                </form>
              </div>
            </simplebar>
          </div>
        </div>
      </div>
    </div>


    <!--    <div class="modal fade" id="div_ViewVendorsModal" tabindex="-1" role="dialog">
          <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
            <div class="modal-content">
              <div class="modal-header justify-content-between pt-3">
                <span class="title">فروشندگان</span>
                <span data-dismiss="modal" class="btn btn-link text-muted pt-0">بستن</span>
              </div>
              <div class="modal-body">
                <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:400px;">
                  <div>
                    <ul class="pr-0">
                      <li v-for="item in vendors" v-bind:key="item._id">
                        {{ `${item.Users.FirstName} ${item.Users.LastName} (${item.Users.Mobile})` }}
                        <span
                            :class="{'text-danger':item.Users.UserActive,'text-success':!item.Users.UserActive}">{{
                            item.Users.UserActive === false ? "غیرفعال" : "فعال"
                          }}</span>
                      </li>
                    </ul>
                  </div>
                </simplebar>
              </div>
            </div>
          </div>
        </div>-->
    <!--    <div class="modal fade" id="div_UserInfoModal" tabindex="-1" role="dialog">
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header justify-content-between pt-3">
                <span class="title" id="defaultModalLabel">اطلاعات کاربر</span>
                <span data-dismiss="modal" class="btn btn-link text-muted">بستن</span>
              </div>
              <div class="modal-body">
                <simplebar
                    class="col-xl-12"
                    data-simplebar-auto-hide="false"
                    style="max-height:400px;"
                >
                  <label>نام</label>
                  <div class="form-group">
                    <input type="text" class="form-control" v-model="userInfo.FirstName" disabled/>
                  </div>
                  <label>نام خانوادگی</label>
                  <div class="form-group">
                    <input type="text" class="form-control" v-model="userInfo.LastName" disabled/>
                  </div>
                  <label>شماره همراه</label>
                  <div class="form-group">
                    <input
                        type="text"
                        class="form-control text-left"
                        v-model="userInfo.Mobile"
                        disabled
                    />
                  </div>


                  <label>شماره کارت</label>
                  <div class="form-group">
                    <input
                        type="text"
                        class="form-control text-left"
                        v-model="userInfo.CardNumber"
                        disabled
                    />
                  </div>


                  <label>کدپذیرندگی</label>
                  <div class="form-group">
                    <input
                        type="text"
                        class="form-control text-left"
                        v-model="userInfo.AcceptanceCode"
                        disabled
                    />
                  </div>
                </simplebar>
              </div>
            </div>
          </div>
        </div>-->
    <!--    <div class="modal fade" id="div_FindShopModal" tabindex="-1" role="dialog">
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header justify-content-between pt-3">
                <span class="title">جستجوی فروشگاه</span>
                <span data-dismiss="modal" class="btn btn-link text-muted">بستن</span>
              </div>
              <div class="modal-body">
                <simplebar
                    class="col-xl-12"
                    data-simplebar-auto-hide="false"
                    style="height:400px;">
                  <label>نام فروشگاه</label>
                  <div class="form-group">
                    <v-select taggable
                              :getOptionLabel="option => option.Title"
                              :options="shopList" v-model="shopSelected">
                      <template slot="option" slot-scope="option">
                        <span class="fa">{{ `${option.Title}` }}</span>
                      </template>
                    </v-select>
                  </div>

                </simplebar>
              </div>
            </div>
          </div>
        </div>-->
  </section>
</template>
<script>
/* eslint-disable */
import axios from "axios";
import simplebar from "simplebar-vue";
import "simplebar/dist/simplebar.min.css";
// import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import Paginate from "vuejs-paginate";
// import Vue from 'vue';
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

// import moment from "vue-moment-jalaali";
// import VueUploadMultipleImage from 'vue-upload-multiple-image';
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";


export default {
  data() {
    return {
      userInfo: {},
      filterFields: {
        FromDate: null,
        ToDate: null,
        SelectFilter: "DateRange",
        BOLNumber: null
      },
      loadingShow: false,
      pageSize: 10,
      pageList: 0,
      pageIndex: undefined,
      installmentsData: {InstallmentList: [], InstallmentsCount: 0},
      shipmentConfirmationFields: {
        BillLading: null,
        SuppCode: null,
        DeliverSuppCode: null,
        AsnNo: null,
        ItemCode: null,
        // ContNo: null,
        // CaseNo: null,
        AppItemQty: null,
        RejItemQty: null,
        ItemRefDoc: null,
        ItemRefDate: null
        // RegisterType:"Bundled"
      },
      shipmentFields: {}

    };
  },
  methods: {
    confirmUnbundledShipment() {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      axios.post("/API/V1/IncomingRemittances/ConfirmUnbundledShipment", self.shipmentConfirmationFields, {
        headers: {
          "Content-Type": "application/json",
          Authorization: userInfo.Token
        }
      })
          .then(function (res) {
            let {Data, Message, Status} = res.data;
            console.log(res.data);
            if (res.data.Status === 1) {
              $("#div_NewContractModal").modal("hide");

            } else {
              self.$toast.open({
                position: "bottom-right",
                message: res.data.Message,
                type: "error",
                duration: 5000
              });
            }
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function (res) {

          });
    },
    filterIncomingRemittances() {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      axios.get("/API/V1/IncomingRemittances/GetIncomingRemittances", {
        params: {
          FromDate: self.filterFields.FromDate,
          ToDate: self.filterFields.ToDate,
          SelectFilter: self.filterFields.SelectFilter,
          BOLNumber: self.filterFields.BOLNumber,
        },
        headers: {
          Authorization: userInfo.Token
        }
      })
          .then(function (res) {
            let {Status, Message, Data} = res.data;
            console.log(res.data);
            if (Status === 1) {
              // self.getInstallments(self.pageIndex);
              $("#div_FilterModal").modal("hide");
              // self.InstallmentId = res.data.Data.InstallmentId;
              /*self.SystemAlert = {
                Status: "alert-success",
                Message: "قرارداد مشتری با موفقیت ذخیره شد"
              };*/
              // self.$router.push({name: "VerifyMobile", params: {Mobile: self.Mobile}});
            } else {
              self.$refs.filterIncomingRemittancesAlert.innerHTML = Message;
              self.$refs.filterIncomingRemittancesAlert.classList.add("alert", "alert-danger");
            }
            /*else{
              self.$toast.open({
                position: "bottom-right",
                message: Message,
                type: "error",
                duration: 5000
              });
            }*/
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function (res) {
            self.loadingShow = false;
            /*self.btnNextStep = {
              Status: false,
              Text: "مرحله بعد"
            }*/
          });
    },
    saveContract() {
      let self = this;
      // self.ModalsStatus.newContractDisplayModal.hide();
      // self.ModalsStatus.SaveContractResultModal.show();
      axios.post("/Web/V2/Users/AddUser", {
        ContractFields: self.contractFields
      }, {
        headers: {
          "Content-Type": "application/json"
        }
      })
          .then(function (res) {
            console.log(res.data);
            if (res.data.Status === 1) {
              self.getInstallments(self.pageIndex);
              $("#div_NewContractModal").modal("hide");
              // self.InstallmentId = res.data.Data.InstallmentId;
              /*self.SystemAlert = {
                Status: "alert-success",
                Message: "قرارداد مشتری با موفقیت ذخیره شد"
              };*/
              // self.$router.push({name: "VerifyMobile", params: {Mobile: self.Mobile}});
            } else {
              self.$toast.open({
                position: "bottom-right",
                message: res.data.Message,
                type: "error",
                duration: 5000
              });
            }
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function (res) {
            /*self.btnNextStep = {
              Status: false,
              Text: "مرحله بعد"
            }*/
          });
      // self.$router.push({name: "AlertSystem_Carpethall", params: {Message: "self.Mobile"}});
    },
    openFindCustomerModal() {
      $("#div_FilterModal").modal("show");
    },
    openNewContractModal() {
      $("#div_NewContractModal").modal("show");
    },
    openContractFileUploadModal(item) {
      let self = this;
      Object.assign(self.contractFields, item.User);
      Object.assign(self.contractFields, item);
      /*self.contractFields._id = item._id;
      self.contractFields.Files = item.Files;
      self.contractFields.User.Mobile=item.User.Mobile;*/
      // console.log(item);
      $("#div_ContractFilesModal").modal("show");
    },
    onChangeContractFile() {
      let self = this;
      self.contractFields.ContractFile.Document = self.$refs.fu_ContractFile.files[0];
      // console.log(this.contractFields);
    },
    uploadFile() {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      let formData = new FormData();
      formData.append("DocumentType", self.contractFields.ContractFile.DocType);
      formData.append("DocumentFile", self.contractFields.ContractFile.Document);
      formData.append("_id", self.contractFields._id);
      formData.append("test", "self.contractFields._id");
      console.log(formData)
      self.loadingShow = true;

      axios
          .post(`/Web/V2/Users/UploadContractFile`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: userInfo.Token
            }
          })
          .then(function (res) {
            console.log(res.data);
            let {Data, Message, Status} = res.data;
            if (Status === 1) {
              $("#div_ContractFilesModal").modal("hide");
              self.getInstallments(self.pageIndex, self.pageSize);
              self.$toast.open({
                position: "bottom-right",
                message: Message,
                type: "success",
                duration: 5000
              });
            } else {
              self.$toast.open({
                position: "bottom-right",
                message: Message,
                type: "error",
                duration: 5000
              });
            }
          })
          .catch(function () {
            self.loadingShow = false;
          })
          .finally(function () {
            self.loadingShow = false;
          });
    },
    removeChequeFromList(index) {
      let self = this;
      self.contractFields.ChequeList.splice(index, 1);
    },
    addChequeToList() {
      let self = this;
      self.contractFields.ChequeList.push({
        ChequeHolder: self.contractFields.ChequeInfo.ChequeHolder,
        BankCheque: self.contractFields.ChequeInfo.BankCheque,
        ChequeAmount: self.contractFields.ChequeInfo.ChequeAmount.toString().replace(/\D/g, ""),
        ChequeDate: self.contractFields.ChequeInfo.ChequeDate
      });
      self.contractFields.ChequeInfo = {
        ChequeHolder: "",
        BankCheque: "",
        ChequeAmount: "",
        ChequeDate: ""
      }
    },
    openCalcInstallmentModal(item) {
      let self = this;
      // self.contractFields = item;
      Object.assign(self.contractFields, item);
      $("#div_CalcInstallmentModal").modal("show");
    },
    retInstallmentStatus(installments) {
      let currentDate = new Date().toJSON();
      let findIndex = installments.findIndex(item => item.DueDate < currentDate);
      return findIndex > -1;
    },
    calcInstallment() {
      let self = this;
      // console.log(self.contractFields);
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      axios.post('/Web/V2/Users/CalcInstallment', {
        ContractFields: self.contractFields
      }, {
        headers: {
          Authorization: userInfo.Token
        }
      }).then(res => {
        let {Message, Status, Data} = res.data;
        // alert(res.data.Message);
        if (Status === 1) {
          self.getInstallments(self.pageIndex);
          // $("#div_EditContractModal").modal("hide");
          self.$toast.open({
            position: "bottom-right",
            message: Message,
            type: "success",
            duration: 5000
          });
        } else {
          self.$toast.open({
            position: "bottom-right",
            message: Message,
            type: "error",
            duration: 5000
          });
        }
      })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function () {
            self.loadingShow = false;
          });
    },
    updateContract() {
      let self = this;
      console.log(self.contractFields);
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      axios.post('/Web/V2/Users/UpdateContract', {
        ContractFields: self.contractFields
      }, {
        headers: {
          Authorization: userInfo.Token
        }
      }).then(res => {
        let {Message, Status, Data} = res.data;
        // alert(res.data.Message);
        if (Status === 1) {
          self.getInstallments(self.pageIndex);
          $("#div_EditContractModal").modal("hide");
          self.$toast.open({
            position: "bottom-right",
            message: Message,
            type: "success",
            duration: 5000
          });
        } else {
          self.$toast.open({
            position: "bottom-right",
            message: Message,
            type: "error",
            duration: 5000
          });
        }
      })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function () {
            self.loadingShow = false;
          });
    },
    /*openDifferencesModal(differences) {
      let self = this;
      self.differences = differences;
      $("#div_DifferencesModal").modal("show");
    },*/
    /*submitPaymentInstallment() {
      let self = this;
      // console.log(self.installmentPayment);
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      axios.post('/API/Panel/V1/Installments/PaymentInstallment', self.installmentPayment, {
        headers: {
          Authorization: userInfo.Token
        }
      }).then(res => {
        // alert(res.data.Message);
        if (res.data.Status === 1) {
          console.log(res.data);
          self.getInstallments(self.pageIndex, self.pageSize);
          self.$toast.open({
            position: "bottom-right",
            message: res.data.Message,
            type: "success",
            duration: 5000
          });
          // self.shopFields.ShopBanners = res.data.Data.ShopBanners;
        } else {
          self.$toast.open({
            position: "bottom-right",
            message: res.data.Message,
            type: "error",
            duration: 5000
          });
        }
      })
          .catch(function (error) {
            console.log(error)
          })
          .finally(function () {
            self.loadingShow = false;
          });
    },*/
    openEditContractModal(item) {
      let self = this;
      console.log(item);
      self.shipmentConfirmationFields.AsnNo = item.asn_no;
      self.shipmentConfirmationFields.BillLading = item.bill_of_lading;
      self.shipmentConfirmationFields.DeliverSuppCode = item.supp_code;
      self.shipmentConfirmationFields.ItemCode = item.item_code;
      $("#div_ShipmentConfirmationModal").modal("show");
      /*let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      axios
          .get("/Web/V2/Users/GetContractById", {
            params: {
              InstallmentId: id
            },
            headers: {
              "Authorization": userInfo.Token
            }
          })
          .then(function (res) {
            let {Data, Message, Status} = res.data;
            if (Status === 1) {
              $("#div_EditContractModal").modal("show");
              Object.assign(self.contractFields, Data.User);
              Object.assign(self.contractFields, Data);
            } else {
              self.$toast(Message, {
                duration: 5000,
                pauseOnHover: true,
                positionY: 'bottom',
                positionX: 'left',
                disableClick: false,
                styles: {
                  color: '#fff',
                  backgroundColor: '#dc3545',
                  'font-family': "IRANSansDN"
                },
                max: 10
              });
            }
            self.loadingShow = false;
          })
          .catch(function () {
            self.loadingShow = false;
          });*/
    },
    openShipmentInfoModal(item) {
      let self = this;
      self.shipmentFields = item;
      console.log(item);
      /*self.shipmentConfirmationFields.AsnNo = item.asn_no;
      self.shipmentConfirmationFields.BillLading = item.bill_of_lading;
      self.shipmentConfirmationFields.DeliverSuppCode = item.supp_code;
      self.shipmentConfirmationFields.ItemCode = item.item_code;*/
      $("#div_ShipmentInfoModal").modal("show");
    },
    openConfirmBundledShipmentModal(item) {
      let self = this;
      console.log(item);
      self.shipmentConfirmationFields.AsnNo = item.asn_no;
      self.shipmentConfirmationFields.BillLading = item.bill_of_lading;
      self.shipmentConfirmationFields.DeliverSuppCode = item.supp_code;
      self.shipmentConfirmationFields.ItemCode = item.item_code;
      $("#div_ConfirmBundledShipmentModal").modal("show");
    },
    openFilterModal() {
      $("#div_InstallmentsFilter").modal("show");
      // let self = this;
      // let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      // self.loadingShow = true;
      /*axios
          .get("/api/panel/Shops/v1/GetShops", {
            headers: {
              authorization: userInfo.Token
            }
          })
          .then(function (res) {
            // console.log(res.data);
            if (res.data.Status === 1) {
              self.shopList = res.data.Data.ShopList;
              $("#div_InstallmentsFilter").modal("show");
            } else {
              self.$toast.open({
                position: "bottom-right",
                message: res.data.Message,
                type: "error",
                duration: 5000
              });
            }
          })
          .catch(function (error) {
            console.log(error)
          })
          .finally(function () {
            self.loadingShow = false;
          });*/
    },
    openFactorsModal(installments) {
      let self = this;
      self.installments = installments;
      console.log(installments)
      $("#div_InstallmentsModal").modal("show");
    },
    /*submitFilter() {
      let self = this;
      // let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.getInstallments(1, 10);
      /!*axios.post('/api/panel/Shops/v1/UploadImage', self.filterFields, {
        headers: {
          Authorization: userInfo.Token
        }
      }).then(res => {
        // alert(res.data.Message);
        if (res.data.Status === 1) {
          self.shopFields.ShopBanners = res.data.Data.ShopBanners;
        } else {
          self.$toast.open({
            position: "bottom-right",
            message: res.data.Message,
            type: "success",
            duration: 5000
          });
        }
      })*!/
    },*/
    getInstallments(pageIndex = 1, limit = 10) {
      let self = this;
      self.pageIndex = pageIndex;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      axios
          .get("/Web/V2/Users/GetInstallmentList", {
            params: {
              PageIndex: pageIndex,
              Limit: limit
            },
            headers: {
              authorization: userInfo.Token
            }
          })
          .then(function (res) {
            // console.log(res.data);
            self.installmentsData.InstallmentList = res.data.Data.InstallmentList;
            self.installmentsData.InstallmentsCount = res.data.Data.InstallmentsCount;
            let pageCount =
                self.installmentsData.InstallmentsCount % self.pageSize === 0
                    ? self.installmentsData.InstallmentsCount / self.pageSize
                    : self.installmentsData.InstallmentsCount / self.pageSize + 1;
            self.pageList = Math.floor(pageCount);
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function () {
            self.loadingShow = false;
          });
    },
    makeContractPDF(id) {
      let self = this;
      self.loadingShow = true;
      axios.post("/Web/V2/Users/MakeContractPDF", {
        InstallmentId: id
      }, {
        headers: {
          "Content-Type": "application/json"
        }
      })
          .then(function (res) {
            // console.log(res.data);
            // self.LoadingShow = false;
            if (res.data.Status === 1) {
              self.loadingShow = false;
              window.open(res.data.Data.FilePath, '_blank');
              // self.InstallmentId=res.data.Data.InstallmentId;
              // self.$router.push({name: "VerifyMobile", params: {Mobile: self.Mobile}});
            } else {
              self.$toast.open({
                position: "bottom-right",
                message: res.data.Message,
                type: "error",
                duration: 5000
              });
            }
          })
          .catch(function (error) {
            self.loadingShow = false;
            console.log(error);
          })
          .finally(function (res) {
            self.loadingShow = false;
          });
    },

  },
  created() {
    let self = this;
    self.installmentsData.InstallmentList = [
      {
        "tracking_number": 2429996025696,
        "bill_of_lading": "03013175423_6764633",
        "supp_code": "185547",
        "supp_name": "شرکت توليدي صنعتي بهران موتور گلپايگان",
        "means_of_transport_desc": "زميني (جاده ايي)",
        "vehicle_type": "سواري",
        "driver2": "ابوالفضل رفعتي",
        "plate_no_i": 91,
        "plate_no_ii": "ع",
        "plate_no_iii": 779,
        "plate_no_iiii": 23,
        "sub_supp_code": "14863",
        "sub_supp_name": "شرکت توليدي صنعتي بهران موتور گلپايگان- سازنده",
        "asn_type": "تامين",
        "asn_no": "0313794444",
        "asn_date": "2024-11-21T20:30:00Z",
        "asn_date_persian": "1403/09/02",
        "shipping_date": "2024-11-21T20:30:00Z",
        "item_code": "5366400046",
        "item_name": "مجموعه اكسل جلو چپ - M15 پلاس",
        "item_uom_name": "مجموعه",
        "item_qty": 198,
        "pcmt_type": "قرارداد",
        "qc_num": "12387984",
        "locn_code": "211800",
        "locn_name": "انبار قطعات توليدي تيبا، ساينا و كوييك",
        "test_rep_path": "9898446_1_98140392.xlsx",
        "status": "ارسال",
        "valid": "Y"
      },
      {
        "tracking_number": 2429996025696,
        "bill_of_lading": "03013175423_6764633",
        "supp_code": "185547",
        "supp_name": "شرکت توليدي صنعتي بهران موتور گلپايگان",
        "means_of_transport_desc": "زميني (جاده ايي)",
        "vehicle_type": "سواري",
        "driver2": "ابوالفضل رفعتي",
        "plate_no_i": 91,
        "plate_no_ii": "ع",
        "plate_no_iii": 779,
        "plate_no_iiii": 23,
        "sub_supp_code": "14863",
        "sub_supp_name": "شرکت توليدي صنعتي بهران موتور گلپايگان- سازنده",
        "asn_type": "تامين",
        "asn_no": "0313794444",
        "asn_date": "2024-11-21T20:30:00Z",
        "asn_date_persian": "1403/09/02",
        "shipping_date": "2024-11-21T20:30:00Z",
        "item_code": "5366400047",
        "item_name": "مجموعه اكسل جلو راست - M15 پلاس",
        "item_uom_name": "مجموعه",
        "item_qty": 198,
        "pcmt_type": "قرارداد",
        "qc_num": "12387985",
        "locn_code": "211800",
        "locn_name": "انبار قطعات توليدي تيبا، ساينا و كوييك",
        "status": "ارسال",
        "valid": "Y"
      },
      {
        "tracking_number": 2430062683325,
        "bill_of_lading": "03013175428_6764642",
        "supp_code": "185547",
        "supp_name": "شرکت توليدي صنعتي بهران موتور گلپايگان",
        "means_of_transport_desc": "زميني (جاده ايي)",
        "vehicle_type": "سواري",
        "driver2": "محمد رضا خرمي",
        "plate_no_i": 15,
        "plate_no_ii": "ع",
        "plate_no_iii": 612,
        "plate_no_iiii": 13,
        "sub_supp_code": "14863",
        "sub_supp_name": "شرکت توليدي صنعتي بهران موتور گلپايگان- سازنده",
        "asn_type": "تامين",
        "asn_no": "0313794445",
        "asn_date": "2024-11-21T20:30:00Z",
        "asn_date_persian": "1403/09/02",
        "shipping_date": "2024-11-21T20:30:00Z",
        "item_code": "5366400046",
        "item_name": "مجموعه اكسل جلو چپ - M15 پلاس",
        "item_uom_name": "مجموعه",
        "item_qty": 180,
        "pcmt_type": "قرارداد",
        "qc_num": "12387992",
        "locn_code": "211800",
        "locn_name": "انبار قطعات توليدي تيبا، ساينا و كوييك",
        "test_rep_path": "9898450_1_35140392.xlsx",
        "status": "ارسال",
        "valid": "Y"
      },
      {
        "tracking_number": 2430062683325,
        "bill_of_lading": "03013175428_6764642",
        "supp_code": "185547",
        "supp_name": "شرکت توليدي صنعتي بهران موتور گلپايگان",
        "means_of_transport_desc": "زميني (جاده ايي)",
        "vehicle_type": "سواري",
        "driver2": "محمد رضا خرمي",
        "plate_no_i": 15,
        "plate_no_ii": "ع",
        "plate_no_iii": 612,
        "plate_no_iiii": 13,
        "sub_supp_code": "14863",
        "sub_supp_name": "شرکت توليدي صنعتي بهران موتور گلپايگان- سازنده",
        "asn_type": "تامين",
        "asn_no": "0313794445",
        "asn_date": "2024-11-21T20:30:00Z",
        "asn_date_persian": "1403/09/02",
        "shipping_date": "2024-11-21T20:30:00Z",
        "item_code": "5366400047",
        "item_name": "مجموعه اكسل جلو راست - M15 پلاس",
        "item_uom_name": "مجموعه",
        "item_qty": 180,
        "pcmt_type": "قرارداد",
        "qc_num": "12387993",
        "locn_code": "211800",
        "locn_name": "انبار قطعات توليدي تيبا، ساينا و كوييك",
        "test_rep_path": "9898450_2_92140392.xlsx",
        "status": "ارسال",
        "valid": "Y"
      },
      {
        "tracking_number": 2430428492753,
        "bill_of_lading": "03013175891_6765353",
        "supp_code": "185547",
        "supp_name": "شرکت توليدي صنعتي بهران موتور گلپايگان",
        "means_of_transport_desc": "زميني (جاده ايي)",
        "vehicle_type": "سواري",
        "driver2": "حسين مجيدي",
        "plate_no_i": 47,
        "plate_no_ii": "ع",
        "plate_no_iii": 988,
        "plate_no_iiii": 43,
        "sub_supp_code": "14863",
        "sub_supp_name": "شرکت توليدي صنعتي بهران موتور گلپايگان- سازنده",
        "asn_type": "تامين",
        "asn_no": "0313794584",
        "asn_date": "2024-11-22T20:30:00Z",
        "asn_date_persian": "1403/09/03",
        "shipping_date": "2024-11-22T20:30:00Z",
        "item_code": "5366430035",
        "item_name": "مجموعه اكسل عقب",
        "item_uom_name": "مجموعه",
        "item_qty": 126,
        "pcmt_type": "قرارداد",
        "qc_num": "12388677",
        "locn_code": "211800",
        "locn_name": "انبار قطعات توليدي تيبا، ساينا و كوييك",
        "test_rep_path": "9898917_1_16140393.xlsx",
        "status": "ارسال",
        "valid": "Y"
      },
      {
        "tracking_number": 2430444045812,
        "bill_of_lading": "03013175938_6765432",
        "supp_code": "185547",
        "supp_name": "شرکت توليدي صنعتي بهران موتور گلپايگان",
        "means_of_transport_desc": "زميني (جاده ايي)",
        "vehicle_type": "سواري",
        "driver2": "محمود فراست",
        "plate_no_i": 12,
        "plate_no_ii": "ع",
        "plate_no_iii": 944,
        "plate_no_iiii": 43,
        "sub_supp_code": "14863",
        "sub_supp_name": "شرکت توليدي صنعتي بهران موتور گلپايگان- سازنده",
        "asn_type": "تامين",
        "asn_no": "0313794583",
        "asn_date": "2024-11-22T20:30:00Z",
        "asn_date_persian": "1403/09/03",
        "shipping_date": "2024-11-22T20:30:00Z",
        "item_code": "5366430035",
        "item_name": "مجموعه اكسل عقب",
        "item_uom_name": "مجموعه",
        "item_qty": 126,
        "pcmt_type": "قرارداد",
        "qc_num": "12388676",
        "locn_code": "211800",
        "locn_name": "انبار قطعات توليدي تيبا، ساينا و كوييك",
        "test_rep_path": "9898914_1_27140393.xlsx",
        "status": "ارسال",
        "valid": "Y"
      }
    ]
    // self.getInstallments();

  },
  watch: {
    pageSize: function (val) {
      this.getInstallments(this.pageIndex, this.pageSize);
    }
  },
  components: {
    simplebar, 'paginate': Paginate, datePicker: VuePersianDatetimePicker,
  }
};
</script>

<style>
.vs__search::placeholder,
.vs__dropdown-toggle,
.vs__dropdown-menu {
  margin-bottom: 5px;
  text-transform: lowercase;
  font-variant: small-caps;
  text-align: right !important;
  direction: rtl !important;
  padding: 2px;
}

.text-right {
  direction: rtl !important;
  text-align: right !important;
}

.reset {
  all: revert;
}

.vpd-icon-btn {
  margin-bottom: 0px !important;
}

.mp-custom-input-text {
  font-size: 25px;
  direction: ltr;
  text-align: left;
}
</style>
